"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethod = void 0;
var ts_money_1 = require("ts-money");
var Customer_1 = __importDefault(require("./Customer"));
var EInvoice_1 = __importDefault(require("./EInvoice"));
var Employee_1 = __importDefault(require("./Employee"));
var LoyaltyRedemption_1 = __importDefault(require("./LoyaltyRedemption"));
var InvoiceItem_1 = __importDefault(require("./InvoiceItem"));
var PartnerAgent_1 = __importDefault(require("./PartnerAgent"));
var Payment_1 = __importDefault(require("./Payment"));
var PaymentStatus_1 = __importDefault(require("./PaymentStatus"));
var Vehicle_1 = __importDefault(require("./Vehicle"));
var Invoice = /** @class */ (function () {
    function Invoice(json) {
        this.id = json.id;
        this.invoiceNumber = json.invoiceNumber;
        this.branchID = json.branchID;
        this.customer = null;
        if (json.customer != null) {
            this.customer = new Customer_1.default(json.customer);
        }
        this.vehicle = null;
        if (json.vehicle != null) {
            this.vehicle = new Vehicle_1.default(json.vehicle);
        }
        if (json.items) {
            this.items = json.items.map(function (invoiceItemJSON) { return new InvoiceItem_1.default(invoiceItemJSON); });
        }
        else {
            this.items = [];
        }
        this.subtotal = ts_money_1.Money.fromInteger(json.subtotalAmount, ts_money_1.Currencies.MYR);
        this.discount = ts_money_1.Money.fromInteger(json.discountAmount, ts_money_1.Currencies.MYR);
        this.tax = ts_money_1.Money.fromInteger(json.taxAmount, ts_money_1.Currencies.MYR);
        this.total = ts_money_1.Money.fromInteger(json.totalAmount, ts_money_1.Currencies.MYR);
        this.createdAt = new Date(json.createdAt);
        if (json.payments) {
            this.payments = json.payments.map(function (paymentJSON) { return new Payment_1.default(paymentJSON); });
        }
        else {
            this.payments = [];
        }
        this.paidAt = json.paidAt != null ? new Date(json.paidAt) : null;
        this.finalizedAt = json.finalizedAt != null ? new Date(json.finalizedAt) : null;
        this.refundedAt = json.refundedAt != null ? new Date(json.refundedAt) : null;
        this.deletedAt = json.deletedAt != null ? new Date(json.deletedAt) : null;
        this.notes = json.notes;
        this.internalNotes = json.internalNotes;
        this.sellingEmployee = null;
        if (json.sellingEmployee != null) {
            this.sellingEmployee = new Employee_1.default(json.sellingEmployee);
        }
        this.sellingPartnerAgent = null;
        if (json.sellingPartnerAgent != null) {
            this.sellingPartnerAgent = new PartnerAgent_1.default(json.sellingPartnerAgent);
        }
        this.loyaltyRedemption = null;
        if (json.loyaltyRedemption != null) {
            this.loyaltyRedemption = new LoyaltyRedemption_1.default(json.loyaltyRedemption);
        }
        this.eInvoice = null;
        if (json.eInvoice != null) {
            this.eInvoice = new EInvoice_1.default(json.eInvoice);
        }
        this.ticketCode = json.ticketCode;
    }
    Invoice.prototype.paymentStatus = function () {
        if (this.deletedAt != null) {
            return PaymentStatus_1.default.Voided;
        }
        if (this.refundedAt != null) {
            return PaymentStatus_1.default.FullyRefunded;
        }
        if (this.paidAt != null) {
            return PaymentStatus_1.default.FullyPaid;
        }
        else if (this.payments.length > 0) {
            return PaymentStatus_1.default.PartiallyPaid;
        }
        else {
            return PaymentStatus_1.default.Unpaid;
        }
    };
    Object.defineProperty(Invoice.prototype, Symbol.toStringTag, {
        get: function () {
            return 'Invoice';
        },
        enumerable: false,
        configurable: true
    });
    return Invoice;
}());
exports.default = Invoice;
var PaymentMethod = /** @class */ (function () {
    function PaymentMethod(id, name) {
        this.id = id;
        this.name = name;
    }
    PaymentMethod.Invalid = new PaymentMethod('invalid', 'Invalid');
    PaymentMethod.Cash = new PaymentMethod('cash', 'Cash');
    PaymentMethod.Card = new PaymentMethod('card', 'Credit/Debit Card');
    PaymentMethod.DuitNow = new PaymentMethod('duitnow', 'DuitNow');
    PaymentMethod.TouchNGo = new PaymentMethod('tng', 'Touch \'n Go');
    PaymentMethod.BankTransfer = new PaymentMethod('banktransfer', 'Bank Transfer');
    PaymentMethod.byID = function (promoTypeID) {
        switch (promoTypeID) {
            case PaymentMethod.Cash.id:
                return PaymentMethod.Cash;
            case PaymentMethod.Card.id:
                return PaymentMethod.Card;
            case PaymentMethod.DuitNow.id:
                return PaymentMethod.DuitNow;
            case PaymentMethod.TouchNGo.id:
                return PaymentMethod.TouchNGo;
            case PaymentMethod.BankTransfer.id:
                return PaymentMethod.BankTransfer;
            default:
                return PaymentMethod.Invalid;
        }
    };
    PaymentMethod.All = [PaymentMethod.Cash, PaymentMethod.Card, PaymentMethod.DuitNow, PaymentMethod.TouchNGo, PaymentMethod.BankTransfer];
    return PaymentMethod;
}());
exports.PaymentMethod = PaymentMethod;
